<script setup>
import { ref, onUpdated, defineProps, defineEmits } from "vue"
import useOrders from "../../use/useOrders"
import * as persianTools from "@persian-tools/persian-tools"
import PersianDate from "persian-date"

const props = defineProps({
  orderProps: {
    required: true,
    type: Object,
  },
})

const toPersianDateTime = (date) => {
  const [datePart] = date.split(" ")
  const [year, month, day] = datePart.split("-")

  const gregorianDate = new Date(year, month - 1, day)
  const persianDate = new PersianDate(gregorianDate)
  return persianDate.format("YYYY/MM/DD")
}

const orderData = ref({
  id: props.orderProps.id,
  tracking_code: props.orderProps.trackingCode,
  user: props.orderProps.user,
  description: props.orderProps.orderDescription,
  delivery_time: props.orderProps.deliveryTime,
  range_time: props.orderProps.timeRange,
  delivery_address: props.orderProps.deliveryAddress,
  total_price: props.orderProps.totalPrice,
  order_status: props.orderProps.status,
})

const statusLabels = {
  PAYING: "در حال پرداخت",
  PENDING: "در انتظار تایید (در حال بررسی)",
  PREPARING_TO_SEND: "آماده سازی برای ارسال",
  DELIVERED: "تحویل داده شده",
  CANCELLED: "لغو شده",
}

const emit = defineEmits(["update:modelValue", "close"])

const { show, loading, onSubmit, closeModal } = useOrders(
  props,
  emit,
  orderData
)

onUpdated(() => {
  orderData.value = {
    id: props.orderProps.id,
    tracking_code: props.orderProps.trackingCode,
    user: props.orderProps.user,
    description: props.orderProps.orderDescription,
    delivery_time: props.orderProps.deliveryTime,
    range_time: props.orderProps.timeRange,
    delivery_address: props.orderProps.deliveryAddress,
    total_price: props.orderProps.totalPrice,
    order_status: props.orderProps.status,
  }

  if (orderData.value.delivery_time) {
    orderData.value.delivery_time = toPersianDateTime(
      orderData.value.delivery_time
    )
  }

  if (orderData.value.tracking_code) {
    orderData.value.tracking_code = persianTools.digitsEnToFa(
      orderData.value.tracking_code
    )
  }

  if (orderData.value.total_price) {
    orderData.value.total_price = new Intl.NumberFormat("fa-IR").format(
      orderData.value.total_price
    )
  }
})
</script>

<template>
  <!-- edit order modal  -->
  <b-modal
    v-model="show"
    @close="closeModal()"
    id="showModal"
    hide-footer
    title=" ویرایش سفارش"
    header-class="p-3 bg-light"
    class="v-modal-custom"
    centered
    no-close-on-backdrop
  >
    <b-overlay
      variant="white"
      opacity="0.75"
      blur="2px"
      :show="loading"
      spinner-variant="success"
      rounded="sm"
    >
      <b-card>
        <b-form
          id="addform"
          class="tablelist-form"
          autocomplete="off"
          @submit.prevent="onSubmit"
        >
          <div class="mb-3">
            <label for="trackingCode" class="form-label"> شماره سفارش</label>
            <input
              type="text"
              id="trackingCode"
              class="form-control"
              placeholder="شماره سفارش"
              v-model="orderData.tracking_code"
              disabled
            />
          </div>

          <div class="mb-3">
            <label for="user" class="form-label">نام مشتری</label>
            <input
              type="text"
              id="user"
              class="form-control"
              placeholder="نام مشتری"
              v-model="orderData.user"
              disabled
            />
          </div>

          <div class="mb-3">
            <label for="deliveryTime" class="form-label"
              >تاریخ دریافت سفارش</label
            >
            <input
              type="text"
              id="deliveryTime"
              class="form-control"
              placeholder="تاریخ دریافت سفارش"
              v-model="orderData.delivery_time"
              disabled
            />
          </div>

          <div class="mb-3">
            <label for="timeRange" class="form-label"
              >بازه زمانی</label
            >
            <input
              type="text"
              id="timeRange"
              class="form-control"
              placeholder="بازه زمانی"
              v-model="orderData.range_time"
              disabled
            />
          </div>

          <div class="mb-3">
            <label for="deliveryAddress" class="form-label"
              >آدرس تحویل سفارش</label
            ><textarea
              class="form-control"
              id="deliveryAddress"
              v-model="orderData.delivery_address"
              rows="3"
              disabled
            ></textarea>
          </div>

          <div class="mb-3">
            <label for="orderDescription" class="form-label"
              >توضیحات سفارش</label
            ><textarea
              class="form-control"
              id="orderDescription"
              v-model="orderData.description"
              rows="3"
              disabled
            ></textarea>
          </div>

          <div class="mb-3">
            <label for="totalPrice" class="form-label">مبلغ سفارش</label>
            <input
              type="text"
              id="totalPrice"
              class="form-control"
              placeholder="مبلغ سفارش"
              v-model="orderData.total_price"
              disabled
            />
          </div>

          <div class="mb-3">
            <label for="status" class="form-label">وضعیت</label>
            <select
              class="form-control"
              data-trigger
              id="statusfield"
              v-model="orderData.order_status"
            >
              <option
                v-for="(label, value) in statusLabels"
                :key="value"
                :value="value"
                :selected="value == orderData.order_status"
              >
                {{ label }}
              </option>
            </select>
          </div>

          <div class="hstack gap-2 justify-content-end">
            <b-button
              type="button"
              id="closemodal"
              variant="light"
              @click="closeModal"
            >
              بستن
            </b-button>
            <b-button type="submit" variant="success"> ویرایش سفارش </b-button>
          </div>
        </b-form>
      </b-card>
    </b-overlay>
  </b-modal>
</template>
